import { SVGAttributes } from 'react'

export function LinkedInIconInverted(props: SVGAttributes<SVGElement>) {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.1667 15.5837H12.0504V10.2759C12.0504 8.82071 11.4974 8.00748 10.3456 8.00748C9.09259 8.00748 8.43794 8.85378 8.43794 10.2759V15.5837H5.43472V5.47255H8.43794V6.83451C8.43794 6.83451 9.34093 5.16364 11.4866 5.16364C13.6312 5.16364 15.1667 6.4733 15.1667 9.18193V15.5837ZM1.85189 4.14858C0.828933 4.14858 0 3.31314 0 2.28279C0 1.25243 0.828933 0.416992 1.85189 0.416992C2.87485 0.416992 3.70329 1.25243 3.70329 2.28279C3.70329 3.31314 2.87485 4.14858 1.85189 4.14858ZM0.301161 15.5837H3.43274V5.47255H0.301161V15.5837Z"
        fill="currentColor"
      />
    </svg>
  )
}
